export const LEDGER_BOARD_OPTIONS = [
  { text: 'Yes', value: 'yes' },
  { text: 'No', value: 'no' },
];

export const JOIST_SIZES = [
  { text: 'Select an option', value: '' },
  { text: '2x6', value: '2x6' },
  { text: '2x8', value: '2x8' },
  { text: '2x10', value: '2x10' },
  { text: '2x12', value: '2x12' },
];

export const JOIST_SPACING = [
  { text: 'Select an option', value: '' },
  { text: '12"', value: 12 },
  { text: '16"', value: 16 },
  { text: '24"', value: 24 },
];

export const BEAM_SIZES = [
  { text: 'Select an option', value: '' },
  { text: '(2) 2x6', value: '(2) 2x6' },
  { text: '(3) 2x6', value: '(3) 2x6' },
  { text: '(2) 2x8', value: '(2) 2x8' },
  { text: '(3) 2x8', value: '(3) 2x8' },
  { text: '(2) 2x10', value: '(2) 2x10' },
  { text: '(3) 2x10', value: '(3) 2x10' },
  { text: '(2) 2x12', value: '(2) 2x12' },
  { text: '(3) 2x12', value: '(3) 2x12' },
];

export const POST_SIZES = [
  { text: 'Select an option', value: '' },
  { text: '4x4', value: '4x4' },
  { text: '6x6', value: '6x6' },
];

export const DECKING_OPTIONS = [
  { text: 'Select an option', value: '' },
  { text: '1 x 6', value: '1 x 6' },
  { text: '1 x 8', value: '1 x 8' },
];

export const FORM_DEFAULT_VALUES = {
  ledgerBoard: 'yes',
  widthFeet: '',
  widthInches: '0',
  lengthFeet: '',
  lengthInches: '0',
  cantileverLengthFeet: '',
  cantileverLengthInches: '0',
  decking: '',
  joistSize: '',
  joistSpacing: '',
  additionalItems: {
    deckHeightFeet: '',
    deckHeightInches: '',
    postSize: '',
    postQuantity: '',
    spanType: 'simplespan',
    beamSize: '',
    quantityOfBeams: '',
    beamSpanFeet: '',
    beamSpanInches: '',
  },
};

export const RESULT_DEFAULT_VALUES = {
  joist: {},
  rim: {},
  ledger: {},
  deck: {},
  beams: {},
  posts: {},
  overage: {},
};

export const TABLE_HEADERS = [
  'Type',
  'Size',
  'Standard Length (ft)',
  'Board Quantity',
  'Recommended Overage',
  'Total Order Quantity',
];

export const JOIST_MAXSPAN_INCHES = {
  '2x6': {
    12: 82,
    16: 74,
    24: 65,
  },
  '2x8': {
    12: 112,
    16: 102,
    24: 89,
  },
  '2x10': {
    12: 138,
    16: 125,
    24: 109,
  },
  '2x12': {
    12: 164,
    16: 149,
    24: 130,
  },
};

export const CANTILEVER_MAX_LENGTH_INCHES = 24;
